import { Container, Graphics, Sprite, Texture } from "pixi.js";

export class PiggyIcon extends Container {

    private circleMask: Graphics;
    private whiteStroke: Graphics;
    private icon: Sprite;

    public constructor(piggyTexture: Texture) {
        super();

        this.icon = new Sprite(piggyTexture);
        this.icon.width = 71;
        this.icon.height = 71;

        const minSize = Math.min(this.icon.width * 0.5, this.icon.height * 0.5);
        const strokeSize = Math.floor(minSize * 0.13);

        this.whiteStroke = new Graphics();
        this.whiteStroke.lineStyle({ width: strokeSize, color: 0xffffff });
        this.whiteStroke.drawCircle((this.icon.width + strokeSize * 0.5) * 0.5, (this.icon.height + strokeSize * 0.5) * 0.5, minSize + strokeSize);

        this.circleMask = new Graphics();
        this.circleMask.beginFill(0xffffff);
        this.circleMask.drawCircle(this.icon.width * 0.5, this.icon.height * 0.5, minSize + strokeSize);
        this.circleMask.endFill();
        this.icon.mask = this.circleMask;
        this.addChild(this.circleMask);

        this.addChild(
            this.icon,
            this.whiteStroke
        );
    }

}
